<script>
  import { fade } from "svelte/transition";
  import Output from "./Output.svelte";
  import IconTitle from "./IconTitle.svelte";
  import { reportCopy, getCopyId } from "../../stores/currentSelections";

  const title = getCopyId($reportCopy, "calculator-outputs-title");
</script>

<div class="pt-4 bg-blue-lightest" transition:fade={{ duration: 300 }}>
  <div class="px-4 border-b border-neutral-3">
    <IconTitle {title} name="tachometer-Light" size={30} mb={4} />
  </div>

  <div class="grid grid-cols-1 gap-1 md:grid-cols-3 bg-neutral-3">
    <Output output="benefitValue" />
    <Output output="estimatedPension" />
    <Output output="inflationAdjustedPension" />
  </div>
</div>

<style>
  .gap-1 {
    column-gap: 1px;
    row-gap: 1px;
  }
</style>
